import { SessionService } from "../../../utils/types";
import type { IApiResponse } from "../../../utils/types/api-response";

export interface IPaymentCardsResponse extends IApiResponse<IPaymentCard[]> {
    warning?: string;
}

export enum NoteTypes {
    INDIVIDUAL_INTAKE_NOTE = "individual_intake_note",
    MINOR_INTAKE_NOTE = "minor_intake_note",
    FAMILY_INTAKE_NOTE = "family_intake_note",
    FAMILY_TREATMENT_REVIEW = "family_treatment_review",
    INDIVIDUAL_TREATMENT_REVIEW = "individual_treatment_review",
    INDIVIDUAL_SOAP_NOTE = "individual_soap_note",
    FAMILY_SOAP_NOTE = "family_soap_note",
    RECORD_OF_DISCLOSURE = "record_of_disclosure",
    CANCELLATION_NOTE = "cancellation_note",
    SUPERVISION_NOTE = "supervision_note",
    TERMINATION_NOTE = "termination_note",
    SAFETY_PLAN = "safety_plan",
    GENERAL_UPDATE_NOTE = "general_update_note",
    SUPERVISOR_CHECK_IN = "supervisor_check_in",
    PAUSE_NOTIFICATION_NOTE = "pause_notification_note",
}

export interface IBill {
    invoice_id: string;
    date_of_service: string;
    insurance_amount: number;
    coinsurance_amount: number;
    cpt_code: string;
    amount_outstanding: number;
    insurance_amount_collected: number;
    coinsurance_amount_collected: number;
    pr100_collected: number;
    pr100_amount: number;
    pr100_outstanding: number;
    provider: {
        user_id: string;
        last_name: string;
        first_name: string;
    };
    service: SessionService;
    note_type: NoteTypes;
    supervisor?: {
        user_id: string;
        last_name: string;
        first_name: string;
    };
}

export interface IBillSummary {
    total_outstanding_amount: number;
    total_coinsurance_amount: number;
    total_pr100_amount: number;
    total_collected_amount: number;
    total_coinsurance_credit: number;
    total_pr100_credit: number;
    total_pr100_outstanding: number;
}

export interface IPaymentSummary {
    clinician: string;
    service: string;
    amount: number;
}

export enum CardTypes {
    DISCOVER_FINANCIAL = "Discover",
    AMERICAN_EXPRESS = "AmericanExpress",
    MASTERCARD = "MasterCard",
    CAPITAL_ONE = "Capital One",
    CHASE = "Chase",
    VISA = "Visa",
    DINERSCLUB = "DinersClub",
    JCB = "JCB",
}

export enum CreatedSource {
    MANTLE = "mantle",
    EXTERNAL = "external",
    PATIENT_PORTAL = "patient_portal",
}

export interface IPaymentCard {
    merchant_customer_id: string;
    profile_id: string;
    payment_profile_id: string;
    masked_card_number: string;
    is_card_expired: boolean;
    expiration_date: string;
    first_name: string;
    last_name: string;
    billing_address: string;
    state: string;
    zip_code: string;
    country: string;
    card_type: CardTypes;
    is_current: boolean;
    payment_card_id: string;
    created_source: CreatedSource;
}

export interface IBillsFilters {
    page?: number;
    limit?: number;
}

export interface IAddPaymentCardPayload {
    card_label?: string;
    save_card?: boolean;
    tokenized_payment: {
        opaque_data: {
            dataDescriptor: string;
            dataValue: string;
        };
        billing_info: {
            first_name: string;
            last_name: string;
            billing_address: string;
            state: string;
            zip_code: string;
            country: string;
        };
    };
}

export interface IChargePaymentCardPayload {
    invoice_ids?: string[];
    note_type?: string;
    amount?: number;
    payment_card_id?: string;
    session_history_id?: string;
    save_card?: boolean;
    payment_card?: {
        card_number?: string;
        card_cvv?: string;
        expiration_date?: string;
        expiration_month?: number;
        expiration_year?: number;
        cardholder_name?: string;
        billing_address?: string;
        state?: string;
        zip_code?: string;
        country?: string;
    } | null;
}
